<section style="margin-top: 89px;">
  <div class="flex justify-between" style="margin-bottom: 23px;">
    <h2>{{section | label}}</h2>
    <button mat-flat-button color="accent" [disabled]="!inputFieldsAreValid" (click)="updateValutazione()">SALVA
      MODIFICHE</button>
  </div>

  <div class="scrollable-table-container">
    <table mat-table [dataSource]="data" class="table table-primary-color">
      <ng-container matColumnDef="Nome">
        <th mat-header-cell *matHeaderCellDef> Nome modulo </th>
        <td [ngClass]="{'warning-text': element.Colore === 'GIALLO', 'error-text': element.Colore === 'ROSSO'}" mat-cell
          *matCellDef="let element; index as i"> {{element.Nome}} </td>
      </ng-container>

      <ng-container matColumnDef="Valore">
        <th mat-header-cell *matHeaderCellDef> Punteggio </th>
        <td mat-cell *matCellDef="let element"
          [ngClass]="{'warning-text': element.Colore === 'GIALLO', 'error-text': element.Colore === 'ROSSO'}">
          <span *ngIf="element.numericValue && element.digitsInfo; else elseBlock">{{ element.numericValue |
            currency:element.Formattazione:element.Formattazione:element.digitsInfo:'it'}}</span>
          <ng-template #elseBlock>{{element.Valore}}</ng-template>
        </td>
      </ng-container>

      <ng-container matColumnDef="Valutazione">
        <th mat-header-cell *matHeaderCellDef> Valutazione </th>
        <td mat-cell *matCellDef="let element; index as i" style="height: 91px;">
          <div *ngIf="!element.Modificabile" style="padding: 16px;">{{element.Valutazione}}</div>
          <div class="kpi-table-field-container">
            <smart-form *ngIf="element.Modificabile" [fields]="element.fieldList"></smart-form>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let element; columns: displayedColumns;">
      </tr>
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" style="text-align: center; padding: 20px 0;" [colSpan]="displayedColumns.length">Nessun
          dato presente al momento.
        </td>
      </tr>
    </table>


  </div>
</section>